/*
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2019, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */
import { h } from "hyperapp";
import PanelItem from "../panel-item";
import LocalStorageAdapter from "../../../../adapters/localStorageAdapter";

/**
 * Profile
 *
 * @desc Profile Panel Item
 */
export default class ProfilePanelItem extends PanelItem {
  init() {
    if (this.inited) {
      return;
    }
    super.init();
  }

  destroy() {
    this.interval = clearInterval(this.interval);
    super.destroy();
  }

  handlePanelOpen = () => {
    document.getElementsByClassName("panel-profile-content")[0]?.classList.toggle("panel-active");
    document.getElementsByClassName("profile-panel-overlay")[0]?.classList.toggle("panel-active");
  }

  handlePanelClose = () => {
    document.getElementsByClassName("panel-profile-content")[0]?.classList.remove("panel-active");
    document.getElementsByClassName("profile-panel-overlay")[0]?.classList.remove("panel-active");
    document.getElementsByClassName("switch-account-panel")[0]?.classList.remove("panel-active");
  }

  showSwitchAccountPanel = () => {
    document.getElementsByClassName("switch-account-panel")[0]?.classList.add("panel-active");
    document.getElementsByClassName("profile-panel-overlay")[0]?.classList.add("panel-active");
  }

  switchAccount = async (accountId) => {
    var lsHelper = new LocalStorageAdapter();
    let helper = this.core.make("oxzion/restClient");
    let response = await helper.request("v1", "user/switchaccount", { accountId: accountId }, "post");
    if (response.status == "success") {
      let user = this.core.getUser();
      user.jwt = response.data.jwt;
      if (lsHelper.supported()) {
        lsHelper.purge("AUTH_token");
      }
      this.core.setUser(user);
      this.core.make("oxzion/profile").update();
      location.reload();
    } else {
      console.log(response.data.errors);
    }
  };

  triggerAction = (action) => {
    this.handlePanelClose();
    switch (action.value) {
      case "editPreferences":
        this.core.run("Preferences");
        break;
      case "signOut":
        this.core.make("osjs/auth").logout();
        break;
      case "switchAccount":
        this.showSwitchAccountPanel();
        break;
      default:
        break;
    }
  };

  render(state, actions) {
    let profileDetails = this.core.make("oxzion/profile").get().key;

    let profileActions = [
      { title: "Edit Preferences", icon: "fa-solid fa-pencil", value: "editPreferences" },
      { title: "Sign Out", icon: "fa-solid fa-right-from-bracket", value: "signOut" },
    ];

    profileDetails.accounts?.length > 1 &&
      profileActions.unshift({ title: "Switch Account", icon: "fa-solid fa-toggle-off", value: "switchAccount" });

    return super.render("profile", [
      h(
        "div",
        {
          className: "osjs-panel-profile",
        },
        [
          h(
            "div",
            {
              className: "profile-panel-overlay popup-background-overlay",
              onclick: () => this.handlePanelClose(),
            }
          ),
          h(
            "div",
            {
              className: "panel-profile-content",
            },
            [
              h(
                "div",
                {
                  className: "profile-info",
                },
                [
                  h("img", {
                    src: profileDetails.icon + "?" + new Date(),
                    alt: "My Profile",
                    className: "profile-info-img",
                    title: "My Profile",
                  }),
                  h(
                    "div",
                    {
                      className: "profile-info-content",
                    },
                    [
                      h("div", {
                        title: profileDetails.name,
                        innerHTML: profileDetails.name,
                        className: "name text-overflow",
                      }),
                      h("div", {
                        title: profileDetails.designation ? profileDetails.designation : "No designation provided",
                        innerHTML: profileDetails.designation ? profileDetails.designation : null,
                        className: "designation text-overflow",
                      }),
                    ],
                  ),
                ],
              ),
              h(
                "div",
                {
                  className: "profile-actions",
                },
                [
                  profileActions?.map((item) => {
                    return h(
                      "div",
                      {
                        onclick: () => this.triggerAction(item),
                        className: "action",
                      },
                      [
                        h("i", {
                          alt: item.title,
                          className: item.icon,
                          title: item.title,
                          style: { color: "#363B3D", fontSize: "16px" },
                        }),
                        h("div", {
                          innerHTML: item.title,
                          className: "action-title",
                        }),
                      ],
                    );
                  }),
                ],
              ),
            ],
          ),
          h(
            "div",
            {
              className: "switch-account-panel",
            },
            [
              h(
                "div",
                {
                  className: "switch-account-header",
                  innerHTML: "Switch Account",
                },
              ),
              h(
                "div",
                {
                  className: "switch-account-options scroll-container",
                },
                profileDetails.accounts?.map((account) => {
                  return h(
                    "div",
                    {
                      onclick: () => this.switchAccount(account.accountId),
                      className: account.accountId === profileDetails.accountId ? "account-option selected" : "account-option",
                    },
                    [
                      h("img", {
                        src: this.core.config("wrapper.url") + "account/logo/" + account.accountId + "?" + new Date(),
                        alt: account.name,
                        className: "account-option-img",
                        title: account.name,
                      }),
                      h("div", {
                        innerHTML: account.name,
                      }),
                      account.accountId === profileDetails.accountId &&
                      h("i", {
                        className: "fa-solid fa-check account-option-check",
                      }),
                    ],
                  );
                })
              ),
              h(
                "div",
                {
                  className: "divider",
                },
              ),
              h(
                "div",
                {
                  onclick: () => this.core.make("osjs/auth").logout(),
                  className: "profile-actions",
                  style: { justifyContent: "center", display: "flex" },
                },
                [
                  h(
                    "div",
                    {
                      className: "action",
                    },
                    [
                      h("i", {
                        alt: "Sign Out",
                        className: "fa-solid fa-right-from-bracket",
                        title: "Sign Out",
                        style: { color: "#363B3D" },
                      }),
                      h("div", {
                        innerHTML: "Sign Out",
                        className: "action-title",
                      }),
                    ]
                  ),
                ],
              ),
            ],
          ),
          h(
            "div",
            {
              className: "panel-profile-icon",
              onclick: () => this.handlePanelOpen(),
            },
            [
              profileDetails["icon"]
                ? h("img", {
                  className: "profile-img",
                  src: profileDetails["icon"] + "?" + new Date(),
                  alt: profileDetails["firstname"],
                  title: "My Profile",
                })
                : h("i", {
                  className: "fa-solid fa-user profile-icon",
                  title: "My Profile",
                }),
            ],
          ),
        ],
      ),
    ]);
  }
}
